module.exports = __webpack_public_path__ + "img/partners-icon.08bffb71.svg";